import React, { useState, useEffect } from 'react';
import { PropertyForm } from './PropertyForm';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Property, postAPI_Create_Subscribed_Property_Products } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Validation from '../../../../../../../components/Validation';
import { fetchServiceRequest } from '../../../../../../../redux/service/actions';
function CreatePropertyForm({ propertyId, groupId, groupCurrency, serviceProvider, featuresUrl, fetchServiceRequest }) {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);

  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);
  const handleSubmit = (data, applicableProducts) => {
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Property}`,
      data,
    })
      .then(
        (res) => {
          applicableProducts.propertyId = res.data.id;
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            AxiosAPI({
              method: 'post',
              url: `${postAPI_Create_Subscribed_Property_Products}`,
              data: applicableProducts,
            })
              .then(
                (res_2) => {
                  setVisible(false);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              );
          }
        }
      );
  };

  return (
    <div>
      <Button
        color="primary"
        className="top-right-button mr-1 mt-2 ml-2"
        outline
        size="xs"
        onClick={() => {
          setVisible(!visible);
        }}
      // style={{ width: '100%', borderRadius: '6px' }}
      >
        + Create a New Property
      </Button>
      <PropertyForm
        formLabel="Create a New Property"
        visible={visible}
        toggle={() => {
          setVisible(!visible);
        }}
        submit={handleSubmit}
        groupId={groupId}
        groupCurrency={groupCurrency}
        provider={featuresUrl}
      />
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>

  );
}

const mapStateToProps = ({ settings, service }) => {
  const { propertyId, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    serviceProvider,
    featuresUrl,
  };
};

export default injectIntl(connect(mapStateToProps, { fetchServiceRequest })(CreatePropertyForm));
